module.exports = __webpack_public_path__ + "img/privilege6.aa5fedce.png";